var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.3,
    height: 72.53,
    viewBox: "0 0 85.3 72.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M32.53,12.36A25.28,25.28,0,0,0,7.35,37.69V59.55a25.18,25.18,0,1,0,50.36,0V37.69A25.28,25.28,0,0,0,32.53,12.36ZM13.08,37.69A19.53,19.53,0,0,1,29.66,18.36V39.75H13.08ZM52,59.55a19.45,19.45,0,1,1-38.89,0v-14H52Zm0-19.8H35.4V18.36A19.53,19.53,0,0,1,52,37.69Zm33.22-4.62-7.45,7.5h4.59a6.48,6.48,0,1,1-6.48-6.52V30.34A12.29,12.29,0,1,0,88.06,42.63h4.59Z",
    transform: "translate(-7.35 -12.36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpRotate);
export default __webpack_public_path__ + "static/media/help_rotate.52b23ce72d534375799bd6fd5b23c109.svg";
export { ForwardRef as ReactComponent };